import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTokenCache } from '@@client/lib/hooks';
import { listVehiclePhotos } from './actions';
export default function loadVehiclePhotos(araVehicleId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$sizeSlug = _ref.sizeSlug,
      sizeSlug = _ref$sizeSlug === void 0 ? null : _ref$sizeSlug,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$perPage = _ref.perPage,
      perPage = _ref$perPage === void 0 ? -1 : _ref$perPage;

  var dispatch = useDispatch();
  var tokenCache = useTokenCache();
  useEffect(function () {
    dispatch(listVehiclePhotos(tokenCache, araVehicleId, {
      sizeSlug: sizeSlug,
      page: page,
      perPage: perPage
    }));
  }, [araVehicleId]);
  return null;
}